import { Input, InputWrapperProps, PasswordInput, PasswordInputProps } from "@mantine/core";
import { useEffect, useRef } from "react";
import { useFormHelperContext } from "../form";
import { useFormState } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";

export interface FieldInputPasswordProps extends PasswordInputProps {
    label: string;
    name: string;
    inputWrapper?: InputWrapperProps;
}

const HORIZONTAL_FORM_CLASSES = {
    label: "flex-grow m-auto",
    root: "flex flex-grow",
};
const HORIZONTAL_FORM_CLASSES_WRAPPER = {
    label: "flex-grow m-auto pr-4 whitespace-nowrap",
    labelWrapper: "flex-grow",
    root: "flex",
};

export const FieldInputPassword: React.FC<FieldInputPasswordProps> = ({ label, name, placeholder, inputWrapper,  ...rest }) => {
    const { register, control, formStore } = useFormHelperContext();
    const { errors } = useFormState({ control });
    const inputRef = useRef<HTMLInputElement | null>(null);
    const isFocused = useRef(false);

    if (!register) {
        throw new Error("Field.Text must be used within a FormHelper component");
    }
    useEffect(() => {
        if (isFocused.current && inputRef.current) {
            inputRef.current.focus();
        }
    }, [errors]);

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <PasswordInput
                    {...register(name)}
                    data-testid={'field-password-' + name}
                    name={name}
                    placeholder={placeholder}
                    classNames={formStore.horizontalForm ? HORIZONTAL_FORM_CLASSES : undefined}
                    ref={(el) => {
                        register(name).ref(el);
                        inputRef.current = el;
                    }}
                    onFocus={() => (isFocused.current = true)}
                    onBlur={() => (isFocused.current = false)}
                    readOnly={formStore.readOnly}
                    inputContainer={(children) => (
                        <div className="flex flex-col w-full">
                            {children}
                        </div>
                    )}
                    {...rest}
                />
                {typeof errors[name]?.message === 'string' && <Input.Error>{errors[name]?.message}</Input.Error>}
            </div>
        </InputWrapper>

    );
};
